import { useEffect } from 'react'
import CreditCardContainer from './credit-card-container'
import AccountSummary from './account-summary'
import Rewards from './rewards'
import TransactionsTable from './transactions-table'
import { useAuth } from '@/contexts/auth.context'

const HomePage = () => {
  const { updatePhoneNumberStatus } = useAuth()

  useEffect(() => {
    updatePhoneNumberStatus()
  }, [updatePhoneNumberStatus])

  return (
    <div
      className="md:px-[10%] md:pt-[2%] pt-4 pb-4 bg-bgGray min-h-[calc(100dvh-var(--offset))]"
      data-testid="homepage-container"
    >
      <div className="grid grid-cols-1 md:grid-cols-6 md:gap-5 w-full md:mt-5 min-h-[520px]">
        {/* Right */}
        <div className="md:col-span-2">
          <div className="max-md:block hidden">
            <CreditCardContainer />
          </div>
          <div className="w-full flex flex-col rounded-t-3xl md:rounded-lg md:shadow bg-white py-6 md:py-8 px-6 max-lg:px-4">
            <div className="hidden md:block">
              <CreditCardContainer />
            </div>
            <Rewards />
          </div>
          <div className="border-b-dGray-200 max-md:border-b-[1px] mx-4" />
        </div>
        {/* Left */}
        <div className="w-full md:col-span-4 h-full md:rounded-lg md:shadow md:border-[1px] md:border-dGray-200 bg-white">
          <AccountSummary />
          <TransactionsTable />
        </div>
      </div>
    </div>
  )
}

export default HomePage
